import {
  Component, OnInit, AfterContentInit, ElementRef,
  ContentChildren, QueryList, ViewChild, Output, EventEmitter, Input, ChangeDetectionStrategy, ChangeDetectorRef
} from '@angular/core';

import { StatefulCSS } from 'src/app/model/stateful_css';
import { ActionGroupComponent } from '../action-group/action-group.component';
import { ActionGroupEvent } from 'src/app/types/actiongroupevent';


@Component({
  selector: 'app-tool-actions',
  templateUrl: './tool-actions.component.html',
  styleUrls: ['./tool-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolActionsComponent implements OnInit, AfterContentInit {

  @ContentChildren(ActionGroupComponent, { descendants: true }) groups !: QueryList<ActionGroupComponent>;
  @ViewChild('actionsDDContainer', { static: true }) actionsDDContainer: ElementRef;
  @ViewChild('actionSel', { static: false }) actionSel: ElementRef;
  @ViewChild('actionsDD', { static: true }) actionsDD: ElementRef;
  @ViewChild('container', { static: true }) container: ElementRef;
  @ViewChild('actionsList', { static: false }) actionsList: ElementRef;
  @Input() name: string;
  @Input() tool: string;
  @Output() actions: EventEmitter<any> = new EventEmitter();
  @Output() groupChanges: EventEmitter<any> = new EventEmitter();
  private viewStates: StatefulCSS;
  private _ready = false;
  constructor(private domNode: ElementRef, private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.viewStates = new StatefulCSS();
    this.viewStates.SetPrefix('tool-action-view');
    this.viewStates.SetMachine(this.container.nativeElement);
    this.viewStates.AddState('all');
    this.viewStates.AddState('single');
    this.viewStates.SetState('all');

  }
  get viewState(): string {
    return this.viewStates.GetCurrentState();
  }
  ngAfterContentInit() {
    let isFirst = true;
    const firstItem: any = {};

    this.groups.forEach((item: ActionGroupComponent, index: number, src: ActionGroupComponent[]) => {
      /*
      const option: HTMLOptionElement = document.createElement('option');
      option.text = item.name;
      option.value = '' + index;
      this.actionSel.nativeElement.add(option);
      */
      item.actions.subscribe((data: ActionGroupEvent) => {
        this.actions.emit({ tool: this, action: data.action, group: data.group, selected: data.selected });
      });


      const optionA: HTMLButtonElement = document.createElement('button');
      optionA.type = 'button';
      optionA.classList.add('dropdown-item');
      optionA.classList.add('btn');
      optionA.classList.add('btn-md');
      optionA.classList.add('btn-primary');
      optionA.value = item.name;
      optionA.textContent = item.name;
      this.actionsDDContainer.nativeElement.appendChild(optionA);

      optionA.addEventListener('click', (event) => {
        this.ActionGroupSelected(item.name, '' + index);
        if (event.preventDefault) {
          event.preventDefault();
        }
        return false;
      });

      if (isFirst) {
        isFirst = false;
        firstItem.text = item.name;
        firstItem.value = '' + index;
      }
      item.UpdateTitle();

    });
    this.actionsDD.nativeElement.addEventListener('click', (event) => {

      $(this.actionsDDContainer.nativeElement).toggleClass('hidden');
    });
    if (firstItem.text) {
      this.ActionGroupSelected(firstItem.text, firstItem.value);
    }
  }
  ActionGroupSelected(text: string, value: string) {
    this.domNode.nativeElement.className = '';

    this.groups.forEach((item: ActionGroupComponent, index: number, src: ActionGroupComponent[]) => {
      item.ToggleActive(index === Number(value));
      if (index === Number(value)) {
        this.groupChanges.emit({ tool: this, group: item });

      }

    });
    $(this.actionsDDContainer.nativeElement).toggleClass('hidden', true);
  }
  ToggleActive(isActive: boolean) {
    $(this.domNode.nativeElement).toggleClass('active', isActive);
    $(this.domNode.nativeElement).toggleClass('sub-active', !isActive);
    this.groups.forEach((item: ActionGroupComponent, index: number, src: ActionGroupComponent[]) => {
      item.UpdateTitle();
    });
  }
}
